import React from 'react';

export default function Accounting() {
  const centerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Full viewport height
  };

  return (
    <div style={centerStyle}>
      <h1>Accounting Page</h1>
    </div>
  );
}
    